import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { ErrorMsgEnum } from '@app/entities/enums/error/error-msg-enum';
import { LababsVacations, VacationsYear } from '@app/entities/models/lababs/lababs-vacations.model';
import { SignedVacations } from '@app/entities/models/mot/signed-vacations/signed-vacations.model';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

export interface VacationsRepository {
  getLababsVacations(): Observable<LababsVacations[]>;
  getExtraInfo(year?: string): Observable<MSafeAny>;
  getSignedVacations(): Observable<SignedVacations[]>;
  getAbsenceAnnualYears(): Observable<VacationsYear[]>;
  onError$: Observable<ErrorMsgEnum>;
}

export const VACATIONS_REPOSITORY = new InjectionToken<VacationsRepository>('VACATIONS_REPOSITORY');
